import { types } from './reducers'

export const useActions = (state, dispatch) => {
  function setLoginSuccess(user) {
    dispatch({ type: types.LOGIN_SUCCESS, payload: user })
  }

  function setLoginFailure() {
    dispatch({ type: types.LOGIN_FAILURE })
  }

  function setMonitoring(monitoring) {
    dispatch({ type: types.SET_MONITORING, payload: monitoring })
  }

  function setHerd(herd) {
    dispatch({ type: types.SET_HERD, payload: herd })
  }

  function setObjects(objects) {
    dispatch({ type: types.SET_OBJECTS, payload: objects })
  }

  function setSearch(cowSearch) {
    dispatch({ type: types.SET_COWSEARCH, payload: cowSearch })
  }

  function setMonitoringData(monitoring_data) {
    dispatch({ type: types.SET_MONITORING_DATA, payload: monitoring_data })
  }

  function setOnline(online) {
    dispatch({ type: types.SET_ONLINE, payload: online })
  }

  function setDelays(delays) {
    dispatch({ type: types.SET_DELAYS, payload: delays })
  }

  function setAlerts(alerts) {
    dispatch({ type: types.SET_ALERTS, payload: alerts })
  }

  function setSort(order) {
    dispatch({ type: types.SET_SORT, payload: order })
  }

  function setSelectedGroup(group) {
    dispatch({ type: types.SET_SELECTED_GROUP, payload: group })
  }

  function setCowsList(data) {
    dispatch({ type: types.SET_COWS_LIST, payload: data })
  }

  function setGroupsList(data) {
    dispatch({ type: types.SET_GROUPS_LIST, payload: data})
  }

  function setZonesList(data) {
    dispatch({ type: types.SET_ZONES_LIST, payload: data})
  }

  function setTimestamp(timestamp) {
    dispatch({ type: types.SET_TIMESTAMP, payload: timestamp})
  }

  return {
    setLoginSuccess,
    setLoginFailure,
    setMonitoring,
    setHerd,
    setObjects,
    setSearch,
    setMonitoringData,
    setOnline,
    setDelays,
    setAlerts,
    setSort,
    setSelectedGroup,
    setCowsList,
    setGroupsList,
    setZonesList,
    setTimestamp,
  }
}